import * as React from 'react';
import { createAssetPath } from '../createAssetPath';
import { AssetPathContext } from '../context/AssetPathContext';
export function AssetPathContextProvider(_ref) {
  var assetEndpoint = _ref.assetEndpoint,
      manifestContent = _ref.manifestContent,
      _ref$assetPrefix = _ref.assetPrefix,
      assetPrefix = _ref$assetPrefix === void 0 ? '' : _ref$assetPrefix,
      children = _ref.children;
  var assetPath = React.useMemo(function () {
    return createAssetPath(assetEndpoint, manifestContent, assetPrefix);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/React.createElement(AssetPathContext.Provider, {
    value: assetPath
  }, children);
}